import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class ServicesService {

  // token = this.authService.getToken();


  options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    }),
  };

  optionsAuth = {
    // Authorization:'Bearer '+window.sessionStorage.getItem('access_token'),
    idUsuario: window.sessionStorage.getItem('idUsuario'),
  };

  headers: HttpHeaders = new HttpHeaders();

  constructor(private http: HttpClient,
    private authService: AuthService) // private authService: AuthService
  {
    this.headers = new HttpHeaders({
      // 'Authorization': 'Bearer '+window.sessionStorage.getItem('access_token'),
      // 'idUsuario': this.authService.getIdUsuario(),
      // 'idCliente': this.authService.getIdCliente()
    });
  }

  changePassword(user: any): Observable<any> {
    return this.http.post(
      environment.apiUrl + '/api/Account/ChangePassword',
      user,
      { headers: this.headers }
    );
  }

  // -----------Usuario

  obtenerModulos(): Observable<any> {
    return this.http.get(environment.apiUrl + '/api/Usuarios/ObtenerModulos', {
      headers: this.headers,
    });
  }

  GetDatosUsuario(): Observable<any> {
    let idUsuario = this.authService.getIdUsuario();
    return this.http.get(
      environment.apiUrl +
      `/api/Usuarios/ObtenerDatosUsuario/${idUsuario}`,
      { headers: this.headers }
    );
  }


  ENCRYPTION_KEY = '8A8L8U80898R808AR3A04M43C3LAG738';
  ENCRYPTION_IV = '8A8L8U80898R808A';
  encryptData = (data: string) => {
    const encrypted = CryptoJS.AES.encrypt(
      data,
      CryptoJS.enc.Utf8.parse(this.ENCRYPTION_KEY),
      {
        iv: CryptoJS.enc.Utf8.parse(this.ENCRYPTION_IV),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      },
    ).toString();

    return encrypted;
  };

  /*  a(): Observable<any> {
 
     const encryptedUserName = this.encryptData('pjdd@gmail.com');
     const encryptedPassword = this.encryptData('Pipe1234*');
 
     const params = new URLSearchParams();
     params.append('domain', 'realbot.glogic.com.co'); // Este es el valor que envías para 'damain'
     params.append('grant_type', 'password'); // El tipo de grant (puede ser 'password' o 'client_credentials')
     params.append('UserName', encryptedUserName); // Enviar el usuario encriptado
     params.append('Password', encryptedPassword);
 
     return this.http.post(`https://realbot.glogic.com.co/token`, params);
   } */

  GetDatosUsuarioId(idUsuario: any): Observable<any> {
    const idCliente: any = sessionStorage.getItem('idCliente')
    this.headers = new HttpHeaders({
      idCliente
    });
    console.log(this.authService.getIdUsuario());
    console.log(idUsuario);

    return this.http.get(
      environment.apiUrl + `/api/Usuarios/ObtenerDatosUsuario/${idUsuario}`,
      { headers: this.headers }
    );
  }

  GetDataImage(): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/api/Cliente/ObtenerDatosCliente/`,
      { headers: this.headers }
    );
  }

  ObtenerDesarrolloDeProceso(idProceso: any): Observable<any> {
    const idCliente: any = sessionStorage.getItem('idCliente')
    return this.http.get(
      environment.apiUrl + `/api/Procesos/ObtenerDesarrolloDeProceso/${idProceso}/${idCliente}`,
      { headers: this.headers }
    );
  }

  obtenerTiposAnticipos(): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/api/Procesos/ObtenerTiposAnticipos/`,
      { headers: this.headers }
    );
  }


  obtenerCamposCliente(): Observable<any> {
    const idCliente = sessionStorage.getItem('idCliente') || '';
    return this.http.get(
      environment.apiUrl + `/api/Cliente/ObtenerCamposCliente/${idCliente}`,
      { headers: this.headers }
    );
  }

  eliminarClienteCampo(idCampo: string, idPais: string): Observable<any> {
    const idCliente = sessionStorage.getItem('idCliente') || '';
    return this.http.get(
      environment.apiUrl +
      `/api/Cliente/EliminarClienteCampo/${idCampo}/${idCliente}/${idPais}/`,
      { headers: this.headers }
    );
  }

  crearEditarClienteCampo(data: any): Observable<any> {
    return this.http.post(
      environment.apiUrl + '/api/Cliente/CrearEditarClienteCampo',
      data,
      { headers: this.headers }
    );
  }

  GetCentroCosto(idUbicacion: any, idProceso: any): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/CentroCosto/ObtenerCentrosCosto/${idUbicacion}/${idProceso}`,
      { headers: this.headers }
    );
  }

  obteneArchivoAdjunto(nombreArchivo: any): Observable<any> {
    const idCliente = sessionStorage.getItem('idCliente') || '';
    return this.http.get(
      environment.apiUrl + `/api/Adjunto/ObtenerArchivoAdjuntos/${nombreArchivo}/${idCliente}`,
      {
        headers: this.headers,
        responseType: 'blob' // Importante: Indicar que la respuesta es un blob (binario)
      }
    );
  }

  ObtenerFarmaceuticasPorUsuario(): Observable<any> {
    const idUsuario = sessionStorage.getItem('idUsuario') || '';
    const idCliente = sessionStorage.getItem('idCliente') || '';
    return this.http.get(
      environment.apiUrl +
      `/api/usuarios/ObtenerFarmaceuticasPorUsuario/${idUsuario}/${idCliente}`,
      { headers: this.headers }
    );
  }


  ObtenerMedicosPorUsuario(): Observable<any> {
    const idUsuario = sessionStorage.getItem('idUsuario') || '';
    const idCliente = sessionStorage.getItem('idCliente') || '';
    return this.http.get(
      environment.apiUrl +
      `/api/usuarios/ObtenerMedicosPorUsuario/${idUsuario}/${idCliente}`,
      { headers: this.headers }
    );
  }

  gestionUsuarios(): Observable<any> {
    return this.http.get(environment.apiUrl + `/api/Usuarios/ObtenerUsuarios`, {
      headers: this.headers,
    });
  }

  obtenerBanco(): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/api/FuncionarioTarjetas/ObtenerBancos`,
      { headers: this.headers }
    );
  }

  crearEditar(data: any): Observable<any> {
    return this.http.post(
      environment.apiUrl + '/api/Account/CrearEditarUsuario',
      data,
      { headers: this.headers }
    );
  }

  crearEditarCliente(data: any): Observable<any> {
    return this.http.post(
      environment.apiUrl + '/api/Cliente/CrearEditarCliente',
      data,
      { headers: this.headers }
    );
  }

  obtenerCliente(idCliente: any): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/api/Cliente/ObtenerClientePorId/${idCliente}`,
      { headers: this.headers }
    );
  }

  getCentrosCostos(): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/api/Cliente/ObtenerTipoSeleccionCentroCosto`,
      { headers: this.headers }
    );
  }

  crearFuncionarioTarjeta(data: any): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/FuncionarioTarjetas/CrearFuncionarioTarjeta/${data.IdFuncionario}/${data.Tarjeta}/${data.IdBanco}/${data.Predeterminado}`,
      { headers: this.headers }
    );
  }

  GetCentroCostoFun(userUpdate: any): Observable<any> {
    // const idUsuario = sessionStorage.getItem('idUsuario') || '';

    return this.http.get(
      environment.apiUrl +
      `/api/Usuarios/ObtenerCentrosCostoFuncionario/${userUpdate}`,
      { headers: this.headers }
    );
  }

  crearFuncionarioCentroCosto(data: any): Observable<any> {
    return this.http.post(
      environment.apiUrl + '/api/Usuarios/CrearEditarCentrosCostoFuncionario',
      data,
      { headers: this.headers }
    );
  }

  eliminarFuncionarioTarjeta(
    idUsuario: any,
    numeroTarjeta: any,
    idBanco: any
  ): Observable<any> {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      environment.apiUrl +
      `/api/FuncionarioTarjetas/EliminarFuncionarioTarjeta/${idUsuario}/${numeroTarjeta}/${idBanco}/${idCliente}`,
      { headers: this.headers }
    );
  }

  //------------Tareas
  GetTareas(id: any): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/api/Tareas/ObtenerTareasUsuarioPorEstado/${id}`,
      { headers: this.headers }
    );
  }

  getGastosYsaldoPendiente(): Observable<any> {
    const idUsuario = sessionStorage.getItem('idUsuario')
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      environment.apiUrl + `/api/Informes/ObtenerInformeGastosYSaldoPendiente/${idUsuario}/${idCliente}`,
      { headers: this.headers }
    );
  }

  getGastosEfectivo(): Observable<any> {
    const idUsuario = sessionStorage.getItem('idUsuario')
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      environment.apiUrl + `/api/Informes/ObtenerGastosEfectivoPorDoceMeses/${idUsuario}/${idCliente}`,
      { headers: this.headers }
    );
  }

  getPendientesComoAprobador(): Observable<any> {
    const idUsuario = sessionStorage.getItem('idUsuario')
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      environment.apiUrl + `/api/Tareas/ObtenerPendientesComoAprobador/${idUsuario}/${idCliente}`,
      { headers: this.headers }
    );
  }

  api(): Observable<any> {

    return this.http.get(`http://localhost:3000/posts`);
  }

  getMultiplesTareas(idEstado: any): Observable<any> {
    const idUsuario = sessionStorage.getItem('idUsuario')
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      environment.apiUrl + `/api/Tareas/ObtenerMultiplesTareasUsuarioEstado/${idUsuario}/${idEstado}/${idCliente}`,
      { headers: this.headers }
    );
  }

  CrearRechazarMultiplesTareas(data: any) {

    return this.http.post(
      `${environment.apiUrl}/api/Tareas/CrearEditarMultiplesTareas`, data,
      {
        headers: this.headers
      }
    )
  }

  GetProcesos(id: any, num: string | null = 'null'): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/Procesos/ObtenerProcesosUsuarioEstado/${id}/${num}/null`,
      { headers: this.headers }
    );
  }

  GetProcesosHome(id: any, num: string | null = '10'): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/Procesos/ObtenerProcesosUsuarioEstadoInicio/${id}/${num}/null`,
      { headers: this.headers }
    );
  }

  GetProcesosUsuario(idUsuario: string, fechaInicio: any, fechaFin: any): Observable<any> {

    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + window.sessionStorage.getItem('access_token'),
      idUsuario: idUsuario,
      idCliente: sessionStorage.getItem('idCliente') || '',
    });
    let idUsuarioSeleccionado = idUsuario
    let limSuperior = null
    let idEstado = 0
    return this.http.get(
      // environment.apiUrl + `/api/Procesos/ObtenerProcesosUsuarioEstado/0/null/${idUsuario}`,
      environment.apiUrl + `/api/Procesos/ObtenerProcesosUsuarioEstadoConGastos/${idEstado}/${limSuperior}/${idUsuarioSeleccionado}/${fechaInicio}/${fechaFin}`,
      { headers: headers }
    );
  }

  deleteProceso(id: any): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/api/Procesos/EliminarProceso/${id}`,
      { headers: this.headers }
    );
  }

  //------------Legalizacion

  GetConceptos(
    idCategoria: any = 0,
    tipoSolicitud: 'Legalizacion' | 'Anticipo'
  ): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/Conceptos/ObtenerConceptos/${idCategoria}/${tipoSolicitud}`,
      { headers: this.headers }
    );
  }
  GetConceptosGastos(idCategoria: any, idConcepto: any): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/ConceptosGasto/ObtenerConceptosGasto/${idConcepto}`,
      { headers: this.headers }
    );
  }

  /*  GetConceptosGastosSinRestricciones(idConcepto: any): Observable<any> {
     const idCliente: any = sessionStorage.getItem('idCliente')
     let headers = new HttpHeaders({
       idCliente: idCliente
     });
     return this.http.get(
       environment.apiUrl +
       `/api/ConceptosGasto/ObtenerConceptosGastoPorConceptoSinRestricciones/${idConcepto}`,
       { headers: headers }
     );
   } */
  GetConceptoSub(idConcepto: number): Observable<any> {
    // return this.http.get(environment.apiUrl + `/api/ConceptosGasto/ObtenerConceptosSubGasto/${idCategoria}`, {headers: this.headers})
    return this.http.get(
      environment.apiUrl + `/api/ConceptosGasto/ObtenerConceptosSubGasto/${idConcepto}`,
      { headers: this.headers }
    );
  }

  getConceptoGastoAlimento(idCategoria: any, idConceptoGasto: any) {
    const idCliente = sessionStorage.getItem('idCliente') || '';
    return this.http.get(
      environment.apiUrl +
      `/api/ConceptosGasto/ObtenerAlimentosCategoriaConceptoGasto/${idCategoria}/${idConceptoGasto}/${idCliente}`,
      { headers: this.headers }
    );
  }

  GetMoneda(): Observable<any> {
    const idCliente = sessionStorage.getItem('idCliente')
    return this.http.get(environment.apiUrl + `/api/Moneda/ObtenerMonedas/${idCliente}`, {
      headers: this.headers,
    });
  }

  ObtenerVerificacionUsoBotones(idTarea: any): Observable<any> {
    const idUsuario = sessionStorage.getItem('idUsuario')
    return this.http.get(environment.apiUrl + `/api/Procesos/ObtenerVerificacionUsoBotones/${idTarea}/${idUsuario}`, {
      headers: this.headers,
    });
  }

  GetPaises(): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/api/Ubicaciones/ObtenerUbicaciones`,
      { headers: this.headers }
    );
  }

  GetSaldoAnticipoNoAsociados(): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/api/Proceso/ObtenerSaldosSinAsociar/`,
      { headers: this.headers }
    );
  }

  GetCentroCostoFunCiudad(idUbicacion: any): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/Usuarios/ObtenerCentrosCostoFuncionarioPorUbicacion/${idUbicacion}`,
      { headers: this.headers }
    );
  }

  GetProcesosId(idProceso: any): Observable<any> {
    /*  this.headers = new HttpHeaders({
       'idCliente': this.authService.getIdCliente()
     }); */
    return this.http.get(
      environment.apiUrl + `/api/Procesos/ObtenerProcesoPorId/${idProceso}`,
      { headers: this.headers }
    );
  }

  GetObservaciones(idProceso: any): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/Procesos/ObtenerObservacionesProceso/${idProceso}`,
      { headers: this.headers }
    );
  }

  GetUbicacionOrigen(idConceptoGasto: any) {
    const idCliente = sessionStorage.getItem('idCliente') || '';
    return this.http.get(
      environment.apiUrl +
      `/api/ConceptosGasto/ObtenerUbicacionOrigen/${idConceptoGasto}/${idCliente}`,
      { headers: this.headers }
    );
  }

  GetUbicacionDestinoOrigen(idConceptoGasto: any, origen: any) {
    const idCliente = sessionStorage.getItem('idCliente') || '';
    return this.http.get(
      environment.apiUrl +
      `/api/ConceptosGasto/ObtenerUbicacionDestinoPorOrigen/${idConceptoGasto}/${idCliente}/${origen}`,
      { headers: this.headers }
    );
  }

  GetViajesOrigenDestinos(origen: any, destino: any, tipo: any): Observable<any> {
    const idCliente = sessionStorage.getItem('idCliente') || '';
    return this.http.get(
      environment.apiUrl +
      `/api/ConceptosGasto/ObtenerViajesOrigenDestino/${origen}/${destino}/${tipo}/${idCliente}`,
      { headers: this.headers }
    );
  }

  CrearEditarLegalizacion(data: any): Observable<any> {
    console.log(data)
    return this.http.post(
      environment.apiUrl + '/api/Procesos/CrearEditarProceso',
      data,
      { headers: this.headers }
    );
  }

  CrearEditarAnticipo(data: any): Observable<any> {
    return this.http.post(
      environment.apiUrl + '/api/Procesos/CrearEditarAnticipo',
      data,
      { headers: this.headers }
    );
  }

  CrearEditarTarea(data: any): Observable<any> {
    return this.http.post(
      environment.apiUrl + '/api/Tareas/CrearEditarTarea/',
      data,
      { headers: this.headers }
    );
  }

  ObtenerIco() {
    this.headers = new HttpHeaders({
    });

    return this.http.get(
      `${environment.apiUrl}/api/Iva/ObtenerListaIco`,
      {
        headers: this.headers
      }
    )
  }

  ConversionMoneda(data: any): Observable<any> {
    return this.http.post(
      environment.apiUrl + '/api/Conversion/ObtenerConversion/',
      data,
      { headers: this.headers }
    );
  }

  ObtenerTiposExtractos(): Observable<any> {
    return this.http.get(
      environment.apiUrl + '/api/Extractos/ObtenerTiposExtractos',
      { headers: this.headers }
    );
  }

  EmailReader(): Observable<any> {
    return this.http.post(
      environment.apiUrl + '/api/EmailReader/webhook',
      { headers: this.headers }
    );
  }

  ConversionMonedaSaldo(data: any): Observable<any> {
    return this.http.post(
      environment.apiUrl + '/api/Conversion/ObtenerConversionMonedas/',
      data,
      { headers: this.headers }
    );
  }

  deleteGastos(idGasto: any, adjName: any): Observable<any> {
    const headers = new HttpHeaders({
      idUsuario: sessionStorage.getItem('idUsuario') || '',
      idCliente: sessionStorage.getItem('idCliente') || '',
      nombresAdjuntos: adjName,
    });
    return this.http.get(
      environment.apiUrl + `/api/Procesos/EliminarGastoProceso/${idGasto}`,
      { headers: headers }
    );
  }

  obtenerEstadoProceso(): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/api/Procesos/ObtenerEstadoProceso`,
      { headers: this.headers }
    );
  }

  GetSaldosAnticipo(idAnticipo: any): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/api/Proceso/ObtenerSaldosProceso/${idAnticipo}`,
      { headers: this.headers }
    );
  }

  GetConceptosRevision(): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/ConceptosGasto/ObtenerConceptosRevisionContable/`,
      { headers: this.headers }
    );
  }

  GetProcesosRevision(idProceso: any): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/Procesos/ObtenerProcesoRevisionContable/${idProceso}`,
      { headers: this.headers }
    );
  }
  // ------- Conceptos Categorias
  conceptosCategorias(): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/api/Categorias/ObtenerConceptosCategorias`,
      { headers: this.headers }
    );
  }

  listaConceptos(): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/api/Conceptos/ObtenerListaConceptos`,
      { headers: this.headers }
    );
  }

  listaCategorias(): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/api/Categorias/ObtenerCategorias`,
      { headers: this.headers }
    );
  }

  CrearEditarConceptoCategoria(data: any): Observable<any> {
    return this.http.post(
      environment.apiUrl + '/api/Conceptos/CrearEditarConceptoCategoria',
      data,
      { headers: this.headers }
    );
  }

  // --------------- Conceptos Gastos

  listaGastos(): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/api/ConceptosGasto/ObtenerListaConceptosGasto`,
      { headers: this.headers }
    );
  }

  gastosCategorias(): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/ConceptosGasto/ObtenerConceptosGastosCategorias`,
      { headers: this.headers }
    );
  }

  CrearEditarConceptoGastoCategoria(data: any): Observable<any> {
    return this.http.post(
      environment.apiUrl +
      '/api/ConceptosGasto/CrearEditarConceptoGastoCategoria',
      data,
      { headers: this.headers }
    );
  }

  // ------ Cuentas
  getCuentas(): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/api/ConceptoCuenta/ObtenerConceptoCuentas`,
      { headers: this.headers }
    );
  }

  getDetalleCuenta(data: any): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/ConceptoCuenta/ObtenerConceptoCuentaDetalle/${data.IdCategoria}/${data.IdConcepto}/${data.IdConceptoGasto}`,
      { headers: this.headers }
    );
  }

  crearEditarCuentaConcepto(data: any): Observable<any> {
    return this.http.post(
      environment.apiUrl + '/api/ConceptoCuenta/CrearEditarConceptoCuenta',
      data,
      { headers: this.headers }
    );
  }

  // -------- Conversion millas
  GetConversion(data: any): Observable<any> {
    return this.http.post(
      environment.apiUrl + '/api/Conversion/ObtenerConversionMillas/',
      data,
      { headers: this.headers }
    );
  }

  // ------- Extracto
  GetExtractos(fechaInicio: string, fechaFin: string, idTipoExtracto: any): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/Extractos/ObtenerExtractos/${fechaInicio}/${fechaFin}/${idTipoExtracto}`,
      { headers: this.headers }
    );
  }

  deleteExtractos(idExtracto: any): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/api/Extractos/EliminarExtracto/${idExtracto}`,
      { headers: this.headers }
    );
  }

  GetFuncionarios(): Observable<any> {
    return this.http.get(
      environment.apiUrl + '/api/Usuarios/ObtenerFuncionarios/',
      { headers: this.headers }
    );
  }
  /*  consultarCUFE(cufe: string): Observable<any> {
     return this.http.post('http://localhost:3000/consulta-dian', {
       trackId: cufe,
       token: '65ca091187f40456f77251ba1afc29243b5b5686488c84202d4388f36e5ba426'
     },
       {
         responseType: 'blob' as 'json'  // 👈 obligatorio para manejar PDF
       }
     )
   } */


  GetFunTarjetas(idFuncionario: any): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/FuncionarioTarjetas/ObtenerTarjetaFuncionario/${idFuncionario}/null`,
      { headers: this.headers }
    );
  }

  GetDetalleExtractoTarjeta(data: any): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/Extractos/ObtenerDetalleExtractoTarjeta/${data.NumTarjeta}/${data.anio}/${data.Mes}/${data.semana}`,
      { headers: this.headers }
    );
  }

  CrearAsociacion(data: any): Observable<any> {
    return this.http.post(
      environment.apiUrl + '/api/Extractos/CrearAsociacion/',
      data,
      { headers: this.headers }
    );
  }

  eliminarAsociacion(idGasto: any, idDetalleExtracto: any): Observable<any> {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      environment.apiUrl +
      `/api/Extractos/EliminarAsociacionGastoDetalleExtracto/${idGasto}/${idDetalleExtracto}/${idCliente}`,
      { headers: this.headers }
    );
  }

  GetExtractosProceso(idProceso: any): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/api/Extractos/ObtenerExtractoProceso/${idProceso}`,
      { headers: this.headers }
    );
  }

  CrearEditarExtracto(data: any): Observable<any> {
    return this.http
      .post(environment.apiUrl + '/api/Extractos/CrearEditarExtracto/', data, {
        headers: this.headers,
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  ErpAnteriores(fechaInicio: any, fechaFin: any): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/api/Procesos/ObtenerProcesosErp/${fechaInicio}/${fechaFin}`,
      { headers: this.headers }
    );
  }

  CrearEditarProceso(data: any, tipoConsumidor: any): Observable<any> {
    const idUser: any = sessionStorage.getItem("idUsuario");
    const headers = new HttpHeaders({
      idUsuarioProceso: idUser,
      IdTipoConsumidor: String(tipoConsumidor)
    });
    // idUsuarioProceso
    return this.http
      .post(environment.apiUrl + '/api/Procesos/CrearEditarPreProceso', data, {
        headers: headers,
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  GetExtractosXFuncionarios(idUsuario: string): Observable<any> {
    const url = `/api/Extractos/ObtenerExtractoFuncionario/${idUsuario}`;
    return this.http.get(environment.apiUrl + url, { headers: this.headers });
  }


  ObtenerTiposConsumidor(): Observable<any> {
    const url = `/api/Cliente/ObtenerTiposConsumidor`;
    return this.http.get(environment.apiUrl + url, { headers: this.headers });
  }

  GetInformeGeneral(start: string, end: string) {
    const idUsuario = sessionStorage.getItem('idUsuario');
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      environment.apiUrl +
      `/api/Procesos/ObtenerInformeGeneral/${idUsuario}/${idCliente}/${start}/${end}`,
      { headers: this.headers }
    );
  }

  getInformeGeneralGastosCliente(start: any, end: any) {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      environment.apiUrl +
      `/api/Informes/ObtenerInformeGeneralGastosCliente/${start}/${end}/${idCliente}`,
      { headers: this.headers }
    );
  }

  getInformeGeneralAntifraude(fechaInicio: any, fechaFin: any) {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      environment.apiUrl +
      `/api/Informes/ObtenerInformeAntifraude/${fechaInicio}/${fechaFin}/${idCliente}`,
      { headers: this.headers }
    );
  }

  getInformeGeneralAtenciones() {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      environment.apiUrl +
      `/api/Informes/ObtenerInformeAtenciones/${idCliente}`,
      { headers: this.headers }
    );
  }

  getInformePendientes(start: any, end: any) {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      environment.apiUrl +
      `/api/Informes/ObtenerInformePendientes/${idCliente}/${start}/${end}`,
      { headers: this.headers }
    );
  }

  getInformeRevision(start: any, end: any) {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      environment.apiUrl +
      `/api/Informes/ObtenerInformeLegalizacionRevisionExtracto/${idCliente}/${start}/${end}`,
      { headers: this.headers }
    );
  }

  getAprobadores() {
    const idCliente = sessionStorage.getItem('idCliente');
    const headers = this.headers.set('idCliente', idCliente || '');
    return this.http.get(
      `${environment.apiUrl}/api/Usuarios/ObtenerUsuarios`,
      { headers }
    );
  }


  // Reportes de gastos y subgastos
  GetReporte(idProceso: any, idExtracto: any): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/Informes/ObtenerInformeErp/${idProceso}/${idExtracto}`,
      { headers: this.headers }
    );
  }

  obtenerInformeActividadUsuarios(año: any, mes: any): Observable<any> {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      environment.apiUrl +
      `/api/Informes/ObtenerInformeActividadUsuarios/${idCliente}/${mes}/${año}`,
      { headers: this.headers }
    );
  }

  // /api/Informes/ObtenerInformeActividadUsuarios/{idCliente}/{mes}/{año}

  GetReporteByErp(
    idProceso: any,
    idExtracto: any,
    idErp: any
  ): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/Informes/ObtenerInformeErpPorIdErp/${idProceso}/${idExtracto}/${idErp}`,
      { headers: this.headers }
    );
  }

  GetReporteSubByErp(
    idProceso: any,
    idExtracto: any,
    idErp: any
  ): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/Informes/ObtenerInformeErpSubgastosIdErp/${idProceso}/${idExtracto}/${idErp}`,
      { headers: this.headers }
    );
  }

  GetReporteEfectivoByErp(idProceso: any, idErp: any): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/Informes/ObtenerInformeErpPorIdErpEfectivo/${idProceso}/${idErp}`,
      { headers: this.headers }
    );
  }

  GetReporteSubEfectivoByErp(idProceso: any, idErp: any): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/Informes/ObtenerInformeErpSubgastosEfectivoIdErp/${idProceso}/${idErp}`,
      { headers: this.headers }
    );
  }

  GetReporteEfectivo(idProceso: string) {
    return this.http.get(
      environment.apiUrl +
      `/api/Informes/ObtenerInformeErpEfectivo/${idProceso}`,
      { headers: this.headers }
    );
  }

  GetErpSubgastos(idProceso: any, idExtracto: any): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/Informes/ObtenerInformeErpSubgastos/${idProceso}/${idExtracto}`,
      { headers: this.headers }
    );
  }

  GetErpSubgastosEfectivo(idProceso: any): Observable<any> {
    return this.http.get(
      environment.apiUrl +
      `/api/Informes/ObtenerInformeErpSubgastosEfectivo/${idProceso}`,
      { headers: this.headers }
    );
  }

  /* Servicion para la sección de Informes */
  // Cosulta de gastos por concepto
  ObtenerGastoXConcepto(data: any): Observable<any> {
    return this.http
      .post(
        environment.apiUrl + '/api/Informes/ObtenerGastosXConcepto/',
        data,
        { headers: this.headers }
      )
      .pipe(map((result) => result));
  }

  // Cosulta de gastos por funcionario
  ObtenerGastoXFuncionario(data: any): Observable<any> {
    return this.http
      .post(
        environment.apiUrl + '/api/Informes/ObtenerGastoXFuncionario',
        data,
        { headers: this.headers }
      )
      .pipe(map((result) => result));
  }

  GetTareaEquipo(estado: number): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/api/Tareas/ObtenerTareasEquipoPorEstado/${estado}`,
      { headers: this.headers }
    );
  }

  ObtenerInformeDeducibles(fechaInicio: any, fechaFin: any): Observable<any> {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      environment.apiUrl + `/api/Informe/ObtenerInformeDeducibles/${fechaInicio}/${fechaFin}/${idCliente}`,
      { headers: this.headers }
    );
  }

  sendEmail(data: any) {
    return this.http.post(
      environment.apiUrl + '/api/Soporte/EnviarCorreoSoporte/',
      data,
      { headers: this.headers }
    );
  }

  frequentQuestions() {
    return this.http.get(
      environment.apiUrl + `/api/Preguntas/ObtenerPreguntasFrecuentes`,
      { headers: this.headers }
    );
  }

  getAllCentrosCosto() {
    return this.http.get(
      environment.apiUrl + `/api/CentroCosto/ObtenerTodosCentrosCosto`,
      { headers: this.headers }
    );
  }

  //New
  getCategory() {
    return this.http.get(
      environment.apiUrl + `/api/Categorias/ObtenerCategorias/`,
      { headers: this.headers }
    );
  }

  getAreas() {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      environment.apiUrl + `/api/cliente/ObtenerLineas/${idCliente}`,
      { headers: this.headers }
    );
  }

  getRole() {
    return this.http.get(environment.apiUrl + `/api/Usuarios/ObtenerRole/`, {
      headers: this.headers,
    });
  }

  crearEditarConceptoGasto(data: any) {
    return this.http.post(
      environment.apiUrl + '/api/Conceptos/CrearEditarConceptoGasto/',
      data,
      { headers: this.headers }
    );
  }

  // crearEditarConcepto(data: any){
  //   return this.http.post(environment.apiUrl + '/api/Conceptos/CrearEditarConcepto/', data,  {headers: this.headers})
  // }

  eliminarConceptoGasto(idConcepto: any) {
    return this.http.get(
      environment.apiUrl + `/api/Conceptos/EliminarConceptoGasto/${idConcepto}`,
      { headers: this.headers }
    );
  }

  eliminarConcepto(idConcepto: any) {
    return this.http.get(
      environment.apiUrl + `/api/Conceptos/EliminarConcepto/${idConcepto}`,
      { headers: this.headers }
    );
  }

  obtenerProveedores() {
    return this.http.get(
      environment.apiUrl + `/api/Proveedores/ObtenerProveedores`,
      { headers: this.headers }
    );
  }

  obtenerProveedorNit(nit: string) {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      environment.apiUrl +
      `/api/Proveedores/ObtenerTercero/${nit}/${idCliente}`,
      { headers: this.headers }
    );
  }

  deleteProveedor(nit: string) {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      environment.apiUrl +
      `/api/Proveedores/EliminarTercero/${nit}/${idCliente}`,
      { headers: this.headers }
    );
  }

  crearEditarProveedor(data: any) {
    return this.http.post(
      environment.apiUrl + `/api/Proveedores/CrearEditarTercero`,
      data,
      { headers: this.headers }
    );
  }

  obtenerIva() {
    return this.http.get(environment.apiUrl + `/api/Iva/ObtenerListaIva`, {
      headers: this.headers,
    });
  }

  obtenerConceptoIva(idConcepto: any, valor: any) {
    return this.http.get(
      environment.apiUrl +
      `/api/ConceptosGasto/ObtenerIvaConceptoGasto/${idConcepto}/${valor}`,
      { headers: this.headers }
    );
  }

  crearEditarGasto(data: any) {
    return this.http.post(
      environment.apiUrl + `/api/Gastos/CrearEditarGasto/`, data,
      { headers: this.headers }
    );
  }

  obtenerGastoPorId(idGasto: any) {
    return this.http.get(
      environment.apiUrl + `/api/Gastos/ObtenerGastoPorId/${idGasto}`,
      { headers: this.headers }
    );
  }


  ocrReceipt(file: any) {
    const headers = new HttpHeaders({
      Authorization: 'd81aa3eb1b2967a4e7a014e816990836',
    });
    // return this.http.post(`https://logixpenseback.uc.r.appspot.com/ocr`, file, {headers});
    //  return this.http.post(`https://logiback.uc.r.appspot.com/ocr`,file,{ headers }
    return this.http.post(`https://logixpense-back.uc.r.appspot.com/extract-invoice-data`, file, { headers }
    );
  }

  leerOcr(extract_text: any) {
    const headers = new HttpHeaders({
      Authorization: 'd81aa3eb1b2967a4e7a014e816990836',
    });
    return this.http.post(`https://logixpense-back.uc.r.appspot.com/extract-bank-statement-data`, { extract_text: extract_text }, { headers }
    );
  }


  /*  callStreaming(extract_text: any) {
     const headers = new HttpHeaders({
       Authorization: 'd81aa3eb1b2967a4e7a014e816990836',
     });
     return this.http.post(`https://logixpense-back.uc.r.appspot.com/streaming-task`, { extract_text: extract_text }, { headers }
     );
   } */


  guardarAdjunto(namefile: string, file: any) {
    const headersAdj = new HttpHeaders({
      authorization: 'Bearer ' + window.sessionStorage.getItem('access_token'),
      'Content-Type': file.type,
      Name: namefile,
      idUsuario: '' + window.sessionStorage.getItem('idUsuario'),
    });

    const idCliente = sessionStorage.getItem('idCliente');

    return this.http.post(
      `${environment.apiUrl}/api/Adjunto/GuardarAdjunto/${idCliente}`,
      file,
      {
        headers: headersAdj,
      }
    );
  }

  guardarImagenGaleria(file: any) {
    const idUsuario = window.sessionStorage.getItem('idUsuario');
    const idCliente = sessionStorage.getItem('idCliente');

    const headers = new HttpHeaders({
      Authorization: 'd81aa3eb1b2967a4e7a014e816990836',
    });

    return this.http.post(
      `${environment.apiUrl}/api/Adjunto/GuardarImagenGaleria/${idUsuario}/${idCliente}`,
      // `${environment.apiUrl}/api/Adjunto/GuardarMultiplesAdjuntosGaleria/${idUsuario}/${idCliente}`,
      file,
      {
        headers: headers,
      }
    );
  }

  obtenerImagenesGeleriaPorUsuario() {
    const idCliente = sessionStorage.getItem('idCliente');
    const idUsuario = window.sessionStorage.getItem('idUsuario');
    return this.http.get(
      `${environment.apiUrl}/api/Adjunto/ObtenerImagenesGeleriaPorUsuario/${idUsuario}/${idCliente}`,
      {
        headers: this.headers,
      }
    );
  }

  obtenerImagenGeleriaPorUsuario(nombreArchivo: any) {
    const idCliente = sessionStorage.getItem('idCliente');
    // const idUsuario = window.sessionStorage.getItem('idUsuario');
    const headers = new HttpHeaders({
      NombreArchivo: nombreArchivo,
    });
    return this.http.get(
      `${environment.apiUrl}/api/Adjunto/ObtenerArchivoGaleria/${idCliente}`,
      {
        headers: headers,
        responseType: 'blob', // Importante: respuesta como binario
      }
    );
  }

  obtenerImagenesTodasGeleriaPorUsuario(nombreArchivo: any) {

    const idCliente = sessionStorage.getItem('idCliente');

    // const idUsuario = window.sessionStorage.getItem('idUsuario');
    return this.http.post(
      `${environment.apiUrl}/api/Adjunto/ObtenerMultiplesArchivosGaleria/${idCliente}`, nombreArchivo,
    );
  }

  obtenerArchivoGeleriaPorUsuario(nombreArchivo: any) {
    const idCliente = sessionStorage.getItem('idCliente');
    // const idUsuario = window.sessionStorage.getItem('idUsuario');
    return this.http.get(
      `${environment.apiUrl}/api/Adjunto/ObtenerArchivoAdjuntos/${nombreArchivo}/${idCliente}`,
      {
        headers: this.headers,
        responseType: 'blob', // Importante: respuesta como binario
      },
    );
  }

  getContentImages(imageName: string[]) {
    const idCliente = sessionStorage.getItem('idCliente');
    const idUsuario = window.sessionStorage.getItem('idUsuario');
    const headers = new HttpHeaders().set('NombreArchivo', imageName);
    return this.http.get(
      `${environment.apiUrl}/api/Adjunto/ObtenerImagenGaleriaPorNombreArchivo/${idUsuario}/${idCliente}`,
      { headers }
    );
  }

  // /api/Adjunto/ObtenerImagenGaleriaPorNombreArchivo/{idUsuario}/{idCliente}

  eliminarAdjunto(name: string) {
    const headers = new HttpHeaders({
      Nombre: name,
      Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      idUsuario: '' + localStorage.getItem('idUsuario'),
    });

    const idCliente = sessionStorage.getItem('idCliente');

    return this.http.get(
      environment.apiUrl + `/api/Adjunto/EliminarAdjunto/${idCliente}`,
      {
        headers,
      }
    );
  }

  crearEditarProcesoAdjunto(data: any) {
    return this.http.post(
      `${environment.apiUrl}/api/Procesos/CrearEditarProcesoAdjunto`,
      data,
      {
        headers: this.headers,
      }
    );
  }

  obtenerProcesoAdjunto(idProceso: string) {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Procesos/ObtenerProcesoAdjunto/${idProceso}/${idCliente}`,
      {
        headers: this.headers,
      }
    );
  }

  eliminarProcesoAdjunto(idAdjunto: any) {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Procesos/EliminarProcesoAdjunto/${idAdjunto}/${idCliente}`,
      {
        headers: this.headers,
      }
    );
  }

  crearLogTransicional(data: any) {
    return this.http.post(
      `${environment.apiUrl}/api/usuarios/CrearLogTransicional/`,
      data,
      {
        headers: this.headers,
      }
    );
  }

  ObtenerValoresIds(data: any) {
    return this.http.post(
      `${environment.apiUrl}/api/Usuarios/ObtenerValoresIds`,
      data,
      {
        headers: this.headers,
      }
    );
  }

  obtenerLogTransicional(fechaInicio: any, fechaFin: any) {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/usuarios/ObtenerLogTransicional/${idCliente}/${fechaInicio}/${fechaFin}`,
      {
        headers: this.headers,
      }
    );
  }

  descargarArchivos(idProceso: any) {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Adjunto/DescargarArchivosAdjuntos/${idProceso}/${idCliente}`,
      {
        headers: this.headers,
        responseType: 'blob' // Importante: Indicar que la respuesta es un blob (binario)
      }
    )
  }


  descargarArchivosErp(idProcesos: any) {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.post(
      `${environment.apiUrlGlad}/api/Factura/DescargarInformeERP`, idProcesos,
      {
        headers: this.headers,
        responseType: 'blob' // Importante: Indicar que la respuesta es un blob (binario)
      }
    )
  }


  cargarExcelContable(data: any) {
    const idUsuario = window.sessionStorage.getItem('idUsuario');
    //api/Tareas/AprobarTareasPorExcel/{idCliente
    const idCliente = sessionStorage.getItem('idCliente');
    const IdTipoConsumidor = sessionStorage.getItem('IdTipoConsumidor');
    return this.http.post(
      `${environment.apiUrl}/api/Tareas/AprobarTareasPorExcel/${idCliente}/${idUsuario}/${IdTipoConsumidor}`, data,
      {
        headers: this.headers,
        //responseType: 'blob' 
      }
    )
  }







  /* Servicios mios */

  getCategorias() {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/ConceptosGasto/ObtenerCategoriasConceptoGasto/${idCliente}`,
      {
        headers: this.headers
      }
    )
  }

  crearEditarCategorias(data: any) {
    const idCliente = sessionStorage.getItem('idCliente');
    const idCategoria = data.IdCategoria;
    const idConceptoGasto = data.IdConceptoGasto;
    const cuenta = data.Cuenta;
    return this.http.post(
      `${environment.apiUrl}/api/ConceptosGasto/ActualizaCuentaPorCategoriaYConceptoGasto/${idCategoria}/${idConceptoGasto}/${cuenta}/${idCliente}`,
      {
        headers: this.headers
      }
    )
  }

  getParametrosSeleccion() {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/ObtenerParametrosSeleccionPorCliente/${idCliente}`,
      {
        headers: this.headers
      }
    )
  }

  CrearEditarParametrosSeleccion(data: any) {

    return this.http.post(
      `${environment.apiUrl}/api/Procesos/CrearEditarParametrosSeleccion`, data,
      {
        headers: this.headers
      }
    )
  }

  EliminarParametrosSeleccion(data: any) {
    // const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/EliminarParametroSeleccion/${data.IdParametro}/${data.TipoSeleccion}/${data.IdCliente}`,
      {
        headers: this.headers
      }
    )
  }


  getEPS() {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/ObtenerEPS/${idCliente}`,
      {
        headers: this.headers
      }
    )
  }

  CrearEditarEPS(data: any) {

    return this.http.post(
      `${environment.apiUrl}/api/Cliente/CrearEditarEPS`, data,
      {
        headers: this.headers
      }
    )
  }

  EliminarEPS(data: any) {
    // const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/EliminarEPS/${data.IdEPS}/${data.IdCliente}`,
      {
        headers: this.headers
      }
    )
  }

  getIPS() {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/ObtenerIPS/${idCliente}`,
      {
        headers: this.headers
      }
    )
  }

  CrearEditarIPS(data: any) {

    return this.http.post(
      `${environment.apiUrl}/api/Cliente/CrearEditarIPS`, data,
      {
        headers: this.headers
      }
    )
  }

  EliminarIPS(data: any) {
    // const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/EliminarIPS/${data.IdIPS}/${data.IdCliente}`,
      {
        headers: this.headers
      }
    )
  }

  getFarmaceuticas() {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/ObtenerFarmaceuticas/${idCliente}`,
      {
        headers: this.headers
      }
    )
  }

  CrearEditarFarmaceuticas(data: any) {

    return this.http.post(
      `${environment.apiUrl}/api/Cliente/CrearEditarFarmaceutica`, data,
      {
        headers: this.headers
      }
    )
  }

  EliminarFarmaceuticas(data: any) {
    // const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/EliminarFarmaceutica/${data.IdFarmaceutica}/${data.IdCliente}`,
      {
        headers: this.headers
      }
    )
  }

  getIVA() {
    const idCliente: any = sessionStorage.getItem('idCliente');
    this.headers = new HttpHeaders({
      idCliente
    });
    return this.http.get(
      `${environment.apiUrl}/api/Iva/ObtenerListaIva`,
      {
        headers: this.headers
      }
    )
  }

  CrearEditarIVA(data: any) {

    return this.http.post(
      `${environment.apiUrl}/api/Cliente/CrearEditarIVA`, data,
      {
        headers: this.headers
      }
    )
  }

  EliminarIVA(data: any) {
    // const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/EliminarIVA/${data.IdIVA}/${data.IdCliente}`,
      {
        headers: this.headers
      }
    )
  }


  getLinea() {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/ObtenerLineas/${idCliente}`,
      {
        headers: this.headers
      }
    )
  }

  CrearEditarLinea(data: any) {

    return this.http.post(
      `${environment.apiUrl}/api/Cliente/CrearEditarLinea`, data,
      {
        headers: this.headers
      }
    )
  }

  EliminarLinea(data: any) {
    // const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/EliminarLinea/${data.IdLinea}/${data.IdCliente}`,
      {
        headers: this.headers
      }
    )
  }

  getMedicos() {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/ObtenerMedicos/${idCliente}`,
      {
        headers: this.headers
      }
    )
  }

  CrearEditarMedicos(data: any) {

    return this.http.post(
      `${environment.apiUrl}/api/Cliente/CrearEditarMedico`, data,
      {
        headers: this.headers
      }
    )
  }

  EliminarMedicos(data: any) {
    // const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/EliminarMedico/${data.IdMedico}/${data.IdCliente}`,
      {
        headers: this.headers
      }
    )
  }

  getMillas() {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/ObtenerMillas/${idCliente}`,
      {
        headers: this.headers
      }
    )
  }

  CrearEditarMillas(data: any) {

    return this.http.post(
      `${environment.apiUrl}/api/Cliente/CrearEditarMilla`, data,
      {
        headers: this.headers
      }
    )
  }

  EliminarMillas(data: any) {
    // const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/EliminarMilla/${data.idUbicacion}/${data.idMoneda}/${data.IdCliente}`,
      {
        headers: this.headers
      }
    )
  }

  getViajes() {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/ObtenerViajes/${idCliente}`,
      {
        headers: this.headers
      }
    )
  }

  CrearEditarViajes(data: any) {

    return this.http.post(
      `${environment.apiUrl}/api/Cliente/CrearEditarViaje`, data,
      {
        headers: this.headers
      }
    )
  }

  EliminarViajes(data: any) {
    console.log(data);

    // const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/EliminarViaje/${data.Origen}/${data.Destino}/${data.IdConceptoGasto}/${data.IdCliente}`,
      {
        headers: this.headers
      }
    )
  }

  obtenerFarmaceuticasUsuario(idUsuario: any) {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/ObtenerListaFarmaceuticaPorUsuario/${idUsuario}/${idCliente}`,
      {
        headers: this.headers
      }
    )
  }

  crearFarmaceuticaUsuario(data: any) {
    return this.http.post(
      `${environment.apiUrl}/api/Usuarios/CrearUsuarioFarmaceutica`, data,
      {
        headers: this.headers
      }
    )
  }

  eliminarFarmaceuticaUsuario(data: any) {
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/EliminarUsuarioFarmaceutica/${data.IdUsuario}/${data.IdFarmaceutica}/${data.IdCliente}`,
      {
        headers: this.headers
      }
    )
  }


  obtenerMedicosUsuario(idUsuario: any) {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/ObtenerListaMedicoPorUsuario/${idUsuario}/${idCliente}`,
      {
        headers: this.headers
      }
    )
  }


  ObtenerCoincidenciasMedico(texto: any) {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/ObtenerCoincidenciasMedico/${texto}/${idCliente}`,
      {
        headers: this.headers
      }
    )
  }

  crearMedicosUsuario(data: any) {
    return this.http.post(
      `${environment.apiUrl}/api/Usuarios/CrearUsuarioMedico`, data,
      {
        headers: this.headers
      }
    )
  }

  eliminarMedicosUsuario(data: any) {
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/EliminarUsuarioMedico/${data.IdUsuario}/${data.IdMedico}/${data.IdCliente}`,
      {
        headers: this.headers
      }
    )
  }


  getErpAnteriores(fechaInicio: any, fechaFin: any) {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Procesos/ObtenerProcesosTerminadosCliente/${idCliente}/${fechaInicio}/${fechaFin}`,
      {
        headers: this.headers
      }
    )
  }


  getPorSincronizar(idProceso: any) {
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Procesos/ObtenerGastosCoincidentesConImagenesGaleria/${idProceso}`,
      {
        headers: this.headers
      }
    )
  }

  getCantidadImagenes() {
    const idUsuario = sessionStorage.getItem('idUsuario') || '';
    return this.http.get(
      environment.apiUrl +
      `/api/Procesos/ObtenerCantidadImagenesGaleriaPorUsuario/${idUsuario}`,
      { headers: this.headers }
    );
  }


  sincronizar(datos: any) {
    const idUsuario = sessionStorage.getItem('idUsuario') || '';
    const idCliente = sessionStorage.getItem('idCliente') || '';
    return this.http.post(
      environment.apiUrl +
      `/api/Procesos/ActualizarGastosCoincidentesConImagenesGaleria/${idUsuario}/${idCliente}`,
      datos, { headers: this.headers }
    );
  }


  getClientes() {
    const idUsuario = sessionStorage.getItem('idUsuario') || '';
    const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      `${environment.apiUrl}/api/Cliente/ObtenerClientesAdministrador/${idUsuario}/${idCliente}`,
      {
        headers: this.headers
      }
    )
  }


  /* *****************  DIAN  ********************  */

  getInfoDian() {
    // const idCliente = sessionStorage.getItem('idCliente');
    return this.http.get(
      'http://localhost:3000/posts'
      // `${environment.apiUrl}/api/Procesos/ObtenerProcesosTerminadosCliente/${idCliente}`,
      /* {
        headers: this.headers
      } */
    )
  }


  /* *****************  GLAD  ********************  */


  /*   GetFacturas() {
      const idCliente: any = sessionStorage.getItem('idCliente');
  
      this.headers = new HttpHeaders({
        // Authorization: 'Bearer ' + this.token,
        idCliente
      });
  
      return this.http.get(
        `${environment.apiUrlGlad}/api/Factura/GetFacturas`,
        {
          headers: this.headers
        }
      )
    } */

  getProcesos(data: any) {
    const idCliente: any = sessionStorage.getItem('idCliente');

    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token,
      idCliente
    });
    return this.http.get(
      `${environment.apiUrlGlad}/api/Factura/GetProcesos?fechaInicio=${data.fechaEmisionInicio}&fechaFin=${data.fechaEmisionFin}&fechaVencimientoInicio=${data.fechaVencimientoInicio}&fechaVencimientoFin=${data.fechaVencimientoFin}&fechaCargueInicio=${data.fechaCargueInicio}&fechaCargueFin=${data.fechaCargueFin}`,
      {
        headers: this.headers
      }
    )
  }

  getPdf(data: any) {
    const idCliente: any = sessionStorage.getItem('idCliente');

    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token,
      idCliente
    });
    return this.http.post(
      `${environment.apiUrlGlad}/api/Factura/GetAdjuntosZip`,
      data,
      {
        headers: this.headers,
        responseType: 'blob' // Importante: Indicar que la respuesta es un blob (binario)
      }
    )
  }

  getProceso(idProceso: any) {
    // const idCliente: any = sessionStorage.getItem('idCliente');

    this.headers = new HttpHeaders({
      idProceso
    });

    return this.http.get(

      `${environment.apiUrlGlad}/api/Factura/GetProceso`,
      {
        headers: this.headers
      }
    )
  }


  GetFacturas() {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token,

    });
    return this.http.get(
      `${environment.apiUrlGlad}/api/Factura/GetFacturas`,
      {
        headers: this.headers
      }
    )
  }

  GetInvoice(IdProceso: any, idInvoice: any) {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token,
      IdProceso
    });
    return this.http.get(
      `${environment.apiUrlGlad}/api/Factura/GetInvoice/${idInvoice}`,
      {
        headers: this.headers
      }
    )
  }


  GetFacturaProceso(IdProceso: any) {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token,
      IdProceso
    });
    return this.http.get(
      `${environment.apiUrlGlad}/api/Factura/GetFacturaProceso`,
      {
        headers: this.headers
      }
    )
  }


  CreateProceso(data: any) {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token
    });

    return this.http.post(
      `${environment.apiUrlGlad}/api/Factura/CreateProceso`, data,
      {
        headers: this.headers
      }
    )
  }


  UpdateProceso(data: any) {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token
    });

    return this.http.put(
      `${environment.apiUrlGlad}/api/Factura/UpdateProceso`, data,
      {
        headers: this.headers
      }
    )
  }


  UpdateImageProceso(data: any, idProcesoFactura: any) {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token
    });

    return this.http.put(
      `${environment.apiUrlGlad}/api/Factura/GuardarAdjunto/${idProcesoFactura}`, data,
      {
        headers: this.headers
      }
    )
  }


  DeleteFactura(id: any) {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token
    });

    return this.http.delete(
      `${environment.apiUrlGlad}/api/Factura/DeleteFactura/${id}`,
      {
        headers: this.headers
      }
    )
  }


  GetProductos() {
    const idCliente: any = sessionStorage.getItem('idCliente');

    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token,
      idCliente
    });

    return this.http.get(
      `${environment.apiUrlGlad}/api/Producto/GetProductos`,
      {
        headers: this.headers
      }
    )
  }


  GetProveedores() {
    const idCliente: any = sessionStorage.getItem('idCliente');
    this.headers = new HttpHeaders({
      idCliente
    });

    return this.http.get(
      `${environment.apiUrlGlad}/api/Proveedor/GetProveedores`,
      {
        headers: this.headers
      }
    )
  }


  crearProveedores(data: any) {

    return this.http.post(
      `${environment.apiUrlGlad}/api/Proveedor/Create`, data,
      {
        headers: this.headers
      }
    )
  }


  actualizarProveedores(data: any) {

    return this.http.put(
      `${environment.apiUrlGlad}/api/Proveedor/Update/${data.nit}`, data,
      {
        headers: this.headers
      }
    )
  }


  eliminarProveedores(nit: any) {

    return this.http.delete(
      `${environment.apiUrlGlad}/api/Proveedor/Delete/${nit}`,
      {
        headers: this.headers
      }
    )
  }

  reconocerProveedor(nit: any) {

    return this.http.patch(
      `${environment.apiUrlGlad}/api/Proveedor/Reconocer/${nit}`,
      {
        headers: this.headers
      }
    )
  }

  reconocerProducto(id: any) {

    return this.http.patch(
      `${environment.apiUrlGlad}/api/Producto/Reconocer/${id}`,
      {
        headers: this.headers
      }
    )
  }


  crearProductos(data: any) {

    return this.http.post(
      `${environment.apiUrlGlad}/api/Producto/Create`, data,
      {
        headers: this.headers
      }
    )
  }


  actualizarProductos(data: any) {

    return this.http.put(
      `${environment.apiUrlGlad}/api/Producto/Update/${data.id}`, data,
      {
        headers: this.headers
      }
    )
  }

  eliminarProductos(id: any) {

    return this.http.delete(
      `${environment.apiUrlGlad}/api/Producto/Delete/${id}`,
      {
        headers: this.headers
      }
    )
  }


  getTipoProducto() {

    return this.http.get(
      `${environment.apiUrlGlad}/api/TipoProducto/GetAll`,
      {
        headers: this.headers
      }
    )
  }

  getUnidadMedida() {

    return this.http.get(
      `${environment.apiUrlGlad}/api/UnidadMedida/GetAll`,
      {
        headers: this.headers
      }
    )
  }


  getComplejidadProducto() {

    return this.http.get(
      `${environment.apiUrlGlad}/api/ComplejidadProducto/GetAll`,
      {
        headers: this.headers
      }
    )
  }


  getGrupoProductos() {

    return this.http.get(
      `${environment.apiUrlGlad}/api/GrupoProducto/GetAll`,
      {
        headers: this.headers
      }
    )
  }


  getGrupoProducto(id: any) {

    return this.http.get(
      `${environment.apiUrlGlad}/api/GrupoProducto/GetById/${id}`,
      {
        headers: this.headers
      }
    )
  }


  crearGrupoProducto(data: any) {

    return this.http.post(
      `${environment.apiUrlGlad}/api/GrupoProducto/Create`, data,
      {
        headers: this.headers
      }
    )
  }


  actualizarGrupoProducto(data: any) {

    return this.http.put(
      `${environment.apiUrlGlad}/api/GrupoProducto/Update/${data.id}`, data,
      {
        headers: this.headers
      }
    )
  }

  eliminarGrupoProducto(id: any) {

    return this.http.delete(
      `${environment.apiUrlGlad}/api/GrupoProducto/Delete/${id}`,
      {
        headers: this.headers
      }
    )
  }

  getCuentaContable() {

    return this.http.get(
      `${environment.apiUrlGlad}/api/CuentaContable/GetAll`,
      {
        headers: this.headers
      }
    )
  }

  getCuentaContablePorGrupo(idGrupoCuentaContable: any) {

    return this.http.get(
      `${environment.apiUrlGlad}/api/CuentaContable/GetByAccountingGroup/${idGrupoCuentaContable}`,
      {
        headers: this.headers
      }
    )
  }


  crearCuentaContable(data: any) {

    return this.http.post(
      `${environment.apiUrlGlad}/api/CuentaContable/Create`, data,
      {
        headers: this.headers
      }
    )
  }

  editarCuentaContable(data: any) {

    return this.http.put(
      `${environment.apiUrlGlad}/api/CuentaContable/Update/${data.id}`, data,
      {
        headers: this.headers
      }
    )
  }


  deleteCuentaContable(id: any) {

    return this.http.delete(
      `${environment.apiUrlGlad}/api/CuentaContable/Delete/${id}`,
      {
        headers: this.headers
      }
    )
  }

  /* 
    crearCuentaRF(data: any) {
  
      return this.http.post(
        `${environment.apiUrlGlad}/api/CuentaContable/CreateRF`, data,
        {
          headers: this.headers
        }
      )
    }
  
  
    editarCuentaRF(data: any) {
  
      return this.http.put(
        `${environment.apiUrlGlad}/api/CuentaContable/UpdateRF/${data.id}`, data,
        {
          headers: this.headers
        }
      )
    }
  
  
    deleteCuentaRF(id: any) {
  
      return this.http.delete(
        `${environment.apiUrlGlad}/api/CuentaContable/DeleteRF/${id}`,
        {
          headers: this.headers
        }
      )
    } */


  /*   crearCuentaRFICA(data: any) {
  
      return this.http.post(
        `${environment.apiUrlGlad}/api/CuentaContable/CreateRFICA`, data,
        {
          headers: this.headers
        }
      )
    }
  
  
    editarCuentaRFICA(data: any) {
  
      return this.http.put(
        `${environment.apiUrlGlad}/api/CuentaContable/UpdateRFICA/${data.id}`, data,
        {
          headers: this.headers
        }
      )
    }
  
  
    deleteCuentaRFICA(id: any) {
  
      return this.http.delete(
        `${environment.apiUrlGlad}/api/CuentaContable/DeleteRFICA/${id}`,
        {
          headers: this.headers
        }
      )
    } */


  getGrupoProductoPorId(idGrupoProducto: any) {

    return this.http.get(
      `${environment.apiUrlGlad}/api/CuentaContable/GetByGrupo/${idGrupoProducto}`,
      {
        headers: this.headers
      }
    )
  }


  getGrupoCuentaContable() {

    return this.http.get(
      `${environment.apiUrlGlad}/api/GrupoCuentaContable/GetAll`,
      {
        headers: this.headers
      }
    )
  }


  GetTipoComprobante() {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token
    });

    return this.http.get(
      `${environment.apiUrlGlad}/api/TipoComprobante/GetTipoComprobante`,
      {
        headers: this.headers
      }
    )
  }


  GetTipoFactura() {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token
    });

    return this.http.get(
      `${environment.apiUrlGlad}/api/TipoFactura/GetTipoFactura`,
      {
        headers: this.headers
      }
    )
  }

  ocrEntretapas(file: any) {
    const headers = new HttpHeaders({
      Authorization: 'd81aa3eb1b2967a4e7a014e816990836',
    });
    // return this.http.post(`https://logixpenseback.uc.r.appspot.com/ocr`, file, {headers});
    //  return this.http.post(`https://logiback.uc.r.appspot.com/ocr`,file,{ headers }
    return this.http.post(`https://logixpense-back.uc.r.appspot.com/extract-invoice-complete-data`, file, { headers }
    );
  }

  GetCuentasContableRetencionFuente() {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token
    });

    return this.http.get(
      `${environment.apiUrlGlad}/api/Factura/GetCuentasContableRetencionFuente`,
      {
        headers: this.headers
      }
    )
  }


  GetCuentasContableRetencionIca() {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token
    });

    return this.http.get(
      `${environment.apiUrlGlad}/api/Factura/GetCuentasContableRetencionIca`,
      {
        headers: this.headers
      }
    )
  }


  crearTarea(data: any) {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token
    });

    return this.http.post(
      `${environment.apiUrlGlad}/api/Tarea/Create`, data,
      {
        headers: this.headers
      }
    )
  }


  GetInformeERP(idProcesos: any,) {
    /* this.headers = new HttpHeaders({
      idProceso,
      // Authorization: 'Bearer ' + this.token
    }); */

    return this.http.post(
      `${environment.apiUrlGlad}/api/Factura/GetInformeERP`, idProcesos,
      {
        headers: this.headers
      }
    )
  }


  updateTarea(data: any) {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token
    });

    return this.http.put(
      `${environment.apiUrlGlad}/api/Tarea/Update`, data,
      {
        headers: this.headers
      }
    )
  }


  AtencionAlCliente(data: any) {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token
    });

    return this.http.post(
      `${environment.apiUrlGlad}/api/AtencionAlCliente/Create`, data,
      {
        headers: this.headers
      }
    )
  }


  AtencionAlClienteCantidad(/* mes: any, year: any */) {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token
    });

    return this.http.get(
      `${environment.apiUrlGlad}/api/AtencionAlCliente/GetInformeUsoOCR`,
      {
        headers: this.headers
      }
    )
  }


  EmailLectura(count: any, fechaInicio: any, fechaFin: any) {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token
    });

    return this.http.post(
      `${environment.apiUrlGlad}/api/EmailLectura/Ejecutar?count=${count}&fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`, {},
      {
        headers: this.headers
      }
    )
  }



  EmailLecturaEstado(idProcesoCorreo: any) {
    this.headers = new HttpHeaders({
      idProceso: idProcesoCorreo
      // Authorization: 'Bearer ' + this.token
    });

    return this.http.get(
      `${environment.apiUrlGlad}/api/EmailLectura/Estado`,
      {
        headers: this.headers
      }
    )
  }


  buscarProducto(texto: any) {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token
    });

    return this.http.get(
      `${environment.apiUrlGlad}/api/Producto/Buscar?texto=${texto}`,
      {
        headers: this.headers
      }
    )
  }


  buscarProveedor(texto: any) {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token
    });

    return this.http.get(
      `${environment.apiUrlGlad}/api/Proveedor/Buscar?texto=${texto}`,
      {
        headers: this.headers
      }
    )
  }



  deleteEmailCuenta(id: any) {

    return this.http.delete(
      `${environment.apiUrlGlad}/api/EmailCuenta/${id}/revocar`,
      {
        headers: this.headers
      }
    )
  }


  getEmailCuenta() {

    return this.http.get(
      `${environment.apiUrlGlad}/api/EmailCuenta/Get`,
      {
        headers: this.headers
      }
    )
  }


  EmailCuentaUrl(proveedor: any, email: any) {

    return this.http.get(
      `${environment.apiUrlGlad}/api/EmailCuenta/OAuth/Url?proveedor=${proveedor}&email=${email}`,
      {
        headers: this.headers
      }
    )
  }


  EmailCuentaProveedores() {

    return this.http.get(
      `${environment.apiUrlGlad}/api/EmailCuenta/GetProveedores`,
      {
        headers: this.headers
      }
    )
  }


  GetFacturasDuplicadas() {

    return this.http.get(
      `${environment.apiUrlGlad}/api/Factura/GetFacturasDuplicadas`,
      {
        headers: this.headers
      }
    )
  }


  OCRStartProcess(formData: any) {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token
    });

    return this.http.post(
      `${environment.apiUrlGlad}/api/OCR/upload/start-process`, formData,
      {
        headers: this.headers
      }
    )
  }

  SincronizarFacturas(firstDate: any, endDate: any) {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token
    });

    return this.http.post(
      `${environment.apiUrlGlad}/api/Factura/SincronizarFacturas?firstDate=${firstDate}&endDate=${endDate}`,
      {
        headers: this.headers
      }
    )
  }

  /*  GetProcesosEnRevisionContable(inicio: any, fin: any) {
     this.headers = new HttpHeaders({
       // Authorization: 'Bearer ' + this.token
     });
 
     return this.http.get(
       `${environment.apiUrlGlad}/api/Factura/GetProcesosEnRevisionContable?${inicio}=2026-05-01&${fin}=2026-05-31`,
       {
         headers: this.headers
       }
     )
   } */


  ContarArchivosValidos(firstDate: any, endDate: any) {
    this.headers = new HttpHeaders({
      // Authorization: 'Bearer ' + this.token
    });

    return this.http.get(
      `${environment.apiUrlGlad}/api/EmailLectura/ContarArchivosValidos?fechaInicio=${firstDate}&fechaFin=${endDate}`,
      {
        headers: this.headers
      }
    )
  }


  GetProcesosClienteVacio() {

    return this.http.get(
      `${environment.apiUrlGlad}/api/Factura/GetProcesosClienteVacio`,
      {
        headers: this.headers
      }
    )
  }


  GetProcesosClienteDiferente() {

    return this.http.get(
      `${environment.apiUrlGlad}/api/Factura/GetProcesosClienteDiferente`,
      {
        headers: this.headers
      }
    )
  }

  GetCliente() {

    return this.http.get(
      `${environment.apiUrlGlad}/api/Cliente`,
      {
        headers: this.headers
      }
    )
  }


  updateCliente(data: any) {

    return this.http.put(
      `${environment.apiUrlGlad}/api/Cliente`, data,
      {
        headers: this.headers
      }
    )
  }


  /* crearRazon(data: any) {

    return this.http.put(
      `${environment.apiUrlGlad}/api/Cliente/RazonesSociales`, data,
      {
        headers: this.headers
      }
    )
  } */


  estadoFacturas(idProcesoFactura: any) {
    this.headers = new HttpHeaders({
      idProceso: idProcesoFactura
      // Authorization: 'Bearer ' + this.token
    });

    return this.http.get(
      `${environment.apiUrlGlad}/api/OCR/Estado`,
      {
        headers: this.headers
      }
    )
  }



  getAdjuntoFactura(idProcesoFactura: any) {

    // const idCliente = sessionStorage.getItem('idCliente');
    // const idUsuario = window.sessionStorage.getItem('idUsuario');
    return this.http.get(
      `${environment.apiUrlGlad}/api/Factura/GetAdjunto/${idProcesoFactura}`,
      {
        headers: this.headers,
        responseType: 'blob', // Importante: respuesta como binario
      },
    );

  }






}
